<template>
	<div class="items">
		<p class="form_title">
			订单基础信息
		</p>
		<el-form label-width="100px"  v-if="formData" :model="userDate" 
		ref="formRef">
		<el-form-item label="订单编号" prop="no">
		  <el-input v-model="userDate.no" disabled style="width: 365px" placeholder=""></el-input>
		</el-form-item>
			
			<el-form-item label="提车时间" prop="carDate" :rules="[{required: false,message: '请选择提车时间', trigger: 'change'},]">
				<el-date-picker v-model="userDate.carDate" type="datetime" placeholder="选择提车日期"
				style="width:100%" value-format="yyyy-MM-dd HH:mm:ss" />
			</el-form-item>
			
			<el-form-item label="车位类型" prop="carParkingType">
				
				<el-select v-model="userDate.carParkingType"  class="input-small" placeholder="" filterable clearable>
				  <el-option v-for="(item,index) in parkingTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</el-form-item>
			<el-form-item label="取电方式" prop="powerType">
				
				<el-select v-model="userDate.powerType" class="input-small" placeholder="" filterable clearable>
				  <el-option v-for="(item,index) in electricWayOptions" :key="index" :label="item.label" :value="item.value" />
				</el-select>
			</el-form-item>
			
			<el-form-item label="安装地址" prop="villageAddress">
				<el-input v-model="userDate.villageAddress" placeholder="请输入安装地址" />
			</el-form-item>
		</el-form>
		<el-button type="primary" @click="saveBaseInfo">提交</el-button>
	</div>
</template>

<script>
	import request from '../utils/request'
	
	export default {
		props: {
		   formData: {
		     type: Object,
		     required: true,
		     default: () => ({}) // 默认值
		   }
		 },
		data(){
			return {
				order_form: {
					orderType: '',
					orderNo: '',
					saleNo: '',
					brand: '',
					deliverName: '',
					pickupDate: '',
					carColor: '',
					parkingType: '',
					powerType: '',
					addrType: '',
					communityName: '',
					propertyName: '',
					installAddr: '' // 省市区 code 数组
				},
				electricWayOptions:[],
				parkingTypeOptions:[],
				userDate:{},
				formData:{},
				
			}
		},
		watch: {
		   formData: {
		     handler(newVal) {
				 
						this.userDate = newVal;
						 this.$forceUpdate();
		     },
		     deep: true // 深度监听对象内部变化
		   }
		 },
		 mounted() {
			 
		 		  this.userDate =  this.formData;
				
		 		 
		 	    },
		 		created() {
		 		this.getDict("parking_type",this.parkingTypeOptions);	
				this.getDict("electric_way",this.electricWayOptions);	
		 		},
		 		methods: {
		 			
					/**
					 * 保存基础信息
					 */
					saveBaseInfo(){
					 const res = request.post('/applets/qywx/save_base', this.userDate)
					 .then(response => {
					 		 					 this.$message({
					 		 					          message: '保存成功',
					 		 					          type: 'success'
					 		 					        });
					 
					 })
					 .catch(error => {
					   console.error('请求失败:', error)
					   return null // 返回默认值，避免链式调用中断
					 })
					},
		 			/**
		 			 * 获取行政区划树形结构
		 			 */
		 			getDict(data,option) {
		 			  const res = request.get('/applets/qywx/getDictList?code='+data)
		 			  .then(response => {
						  
		 			    console.log('请求成功:', response.data)
						if(data == 'parking_type'){ 
							this.parkingTypeOptions= response.data[data];
							
						}else{
							this.electricWayOptions= response.data[data];
							
						}
		 			    
					   console.log(option)
					    this.$forceUpdate();
						
		 			    // 确保localMsg在当前作用域内已定义（解决潜在的问题2）
		 			    // if (localMsg && localMsg.value !== undefined) {
		 			    //   localMsg.value = response.data
		 			    // }
		 			  })
		 			  .catch(error => {
		 			    console.error('请求失败:', error)
		 			    return null // 返回默认值，避免链式调用中断
		 			  })
		 			},
		 			
		 	   }
		 }
</script>

<style>
</style>